<template>
  <div style="display: flex; align-items: flex-start">
    <sidebar style="margin-right: 20px; max-width: 200px" />
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Felhasználók</span>
        <el-button
          style="float: right; margin-top: -5px;"
          type="success"
          size="small"
          @click="$router.replace('/users/add')"
          icon="el-icon-plus"
          v-can="'user.create'"
        >
          Új felhasználó
        </el-button>
      </div>
      <table-filter
        v-if="config"
        :config="config"
        action="user/fetchAllWithPagination"
      />
      <user-list />
      <template v-if="$route.meta.showViewUserDialog">
        <UserViewDialog
          :userId="$route.params.id"
        />
      </template>
      <template v-if="$route.meta.showAddUserDialog">
        <UserDialog
          type="add"
        />
      </template>
      <template v-if="$route.meta.showUpdateUserDialog">
        <UserDialog
          :userId="$route.params.id"
          type="update"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
  import UserDialog from '../../components/users/Dialog';
  import UserViewDialog from '../../components/users/View';
  import UserList from '../../components/users/List';
  import TableFilter from '../.././components/TableFilter';
  import Sidebar from '../.././components/users/Sidebar';

  export default {
    data() {
      return {
        config: null,
      };
    },
    methods: {
      async setConfig() {
        let roles = this.$store.getters['role/roles'];
        let categories = this.$store.getters['userCategory/userCategories'];
        let locations = this.$store.getters['location/locations'];
        let countries = this.$store.getters['country/countries'];
        let counties = this.$store.getters['county/counties'];
        let users = this.$store.getters['user/users'];
        if (roles.length) {
          roles = roles.map(role => role.name);
        } else {
          await this.$store.dispatch('role/fetchAll');
          roles = this.$store.getters['role/roles'];
          roles = roles.map(role => role.name);
        }
        if (categories.length === 0) {
          await this.$store.dispatch('userCategory/fetchAll');
          categories = this.$store.getters['userCategory/userCategories'];
        }
        if (!locations.length) {
          await this.$store.dispatch('location/fetchAll');
          locations = this.$store.getters['location/locations'];
        }
        if (!countries.length) {
          await this.$store.dispatch('country/fetchAll');
          countries = this.$store.getters['country/countries'];
        }
        if (!counties.length) {
          await this.$store.dispatch('county/fetchAll');
          counties = this.$store.getters['county/counties'];
        }
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.config = [
          {
            type: 'select',
            options: roles,
            name: 'role',
            label: 'Jogkör'
          },
          {
            type: 'select',
            options: locations,
            name: 'location',
            label: 'Terület',
            labelCallback: location => location && `${location.value}` || '',
            valueKey: 'id',
          },
          {
            type: 'cascader',
            options: categories,
            name: 'category',
            label: 'Csoport'
          },
          {
            type: 'text',
            name: 'full_name',
            label: 'Név',
            defaultSearch: true
          },
          {
            type: 'text',
            name: 'nick_name',
            label: 'Becenév',
          },
          {
            type: 'text',
            name: 'mobile',
            label: 'Mobil'
          },
          {
            type: 'text',
            name: 'username',
            label: 'Felhasználónév'
          },
          {
            type: 'text',
            name: 'email',
            label: 'Email'
          },
          {
            type: 'text',
            name: 'private_email',
            label: 'Privát email'
          },
          {
            type: 'text',
            name: 'postal_code',
            label: 'Irányítószám'
          },
          {
            type: 'select',
            options: countries,
            name: 'country',
            label: 'Ország',
            labelCallback: country => country && `${country.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: counties,
            name: 'county',
            label: 'Megye',
            labelCallback: county => county && `${county.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'city',
            label: 'Város',
          },
          {
            type: 'date',
            name: 'birth_date',
            label: 'Születési idő',
          },
          {
            type: 'text',
            name: 'birth_place',
            label: 'Születési hely',
          },
          {
            type: 'text',
            name: 'birth_name',
            label: 'Születési név',
          },
          {
            type: 'text',
            name: 'id_card_number',
            label: 'Szig. Szám',
          },
          {
            type: 'text',
            name: 'social_insurance_number',
            label: 'TB szám',
          },
          {
            type: 'text',
            name: 'tax_id_number',
            label: 'Adóazonosító jel',
          },
          {
            type: 'text',
            name: 'tax_number',
            label: 'Adószám',
          },
          {
            type: 'select',
            options: users,
            name: 'leader_user',
            label: 'Területi vezető',
            labelCallback: user => user && `${user.last_name} ${user.first_name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: [
              { label: 'Igen', value: 1 },
              { label: 'Nem', value: 0 },
            ],
            name: 'is_active',
            label: 'Aktív?',
            labelCallback: active => active && `${active.label}` || '',
            valueKey: 'value',
          },
        ];
      }
    },
    async mounted() {
      await this.setConfig();
    },
    components: {
      UserDialog,
      UserList,
      UserViewDialog,
      TableFilter,
      Sidebar
    },
  };
</script>
